export default "__VITE_ASSET__UA5m534q__"